var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',{attrs:{"size":_vm.size,"fetch-suggestions":_vm.fetchSuggestions,"value-key":"caption","clearable":"","trigger-on-focus":false},on:{"select":_vm.handleSelect},model:{value:(_vm.caption),callback:function ($$v) {_vm.caption=$$v},expression:"caption"}})
}
var staticRenderFns = []

export { render, staticRenderFns }